import { API_NAME } from "./common/constant";

const awsConfig = {
    Auth: {
        identityPoolId: process.env.REACT_APP_AWS_COGNITO_IDENTITY_POOL_ID,
        region: process.env.REACT_APP_AWS_REGION,
        userPoolId: process.env.REACT_APP_AWS_COGNITO_USER_POOL_ID,
        userPoolWebClientId:
            process.env.REACT_APP_AWS_COGNITO_USER_POOL_WEBCLIENT_ID,
    },
    API: {
        endpoints: [
            {
                name: API_NAME,
                endpoint: process.env.REACT_APP_AWS_API_GATEWAY_END_POINT,
                region: process.env.REACT_APP_AWS_REGION,
            },
        ],
    },
};
export default awsConfig;